import * as React from "react";
import { gql, useMutation, ApolloError } from "@apollo/client";
import {
  UpdateOfferMutationMutation,
  UpdateOfferMutationMutationVariables,
} from "../../../../schemaTypes";

export const updateOfferMutation = gql`
  mutation UpdateOfferMutation(
    $offerId: String!
    $input: UpdateOfferInput!
  ) {
    updateOffer(
      offerId: $offerId,
      input: $input
    ) {
      errors {
        path
        message
      }
      message
      bannerUrl
    }
  }
`;

interface Props {
  onMessage?: (message: string) => void;
  children: (
    data: {
      submit: (
        values: UpdateOfferMutationMutationVariables & { bannerFile?: File }
      ) => Promise<{
        errors: ({ path: string; message: string } | null)[] | null;
        message?: string;
        bannerUrl?: string;
      }>;
      loading: boolean;
      error?: ApolloError;
    }
  ) => React.ReactElement | null;
}

function fileToBase64(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result as string);
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
}

export const UpdateOffer: React.FC<Props> = ({ children, onMessage }) => {
  const [updateOffer, { loading, error }] = useMutation<
    UpdateOfferMutationMutation,
    UpdateOfferMutationMutationVariables
  >(updateOfferMutation);

const submit = async (
  values: UpdateOfferMutationMutationVariables & {
    input: UpdateOfferMutationMutationVariables["input"] & {
      bannerFile?: File;
    };
  }
) => {
  const { bannerFile, ...inputRest } = values.input;

  let bannerUrl = inputRest.bannerUrl;

  if (bannerFile) {
    bannerUrl = await fileToBase64(bannerFile);
  }

  const { data } = await updateOffer({
    variables: {
      offerId: values.offerId,
      input: {
        ...inputRest,
        bannerUrl,
      },
    },
  });

  const errors = data?.updateOffer?.errors ?? null;
  const message = data?.updateOffer?.message ?? undefined;
  const bannerUrlResp = data?.updateOffer?.bannerUrl ?? undefined;

  if (message && onMessage) {
    onMessage(message);
  }

  return {
    errors,
    bannerUrl: bannerUrlResp,
    message,
  };
};


  return children({ submit, loading, error });
};